import React from 'react';
import {
  colorsOfengagementTypeCharts,
  TIMELINE_TO_COMPLETION_STATUS_TYPE_LABELS,
} from '@dashboardWirelineContractSpecialistDepartment/constants';
import { map } from 'lodash';
import DashboardBarChart from 'pages/Dashboard/shared/DashboardBarChart';
import { LabelPosition } from 'core/models/Recharts.models';
import {
  mockTimelineToCompletionStatusData,
} from '@dashboardWirelineContractSpecialistDepartment/GetTimelineToCompletionTypeChart/mockTimelineToCompletionStatusData';

const TIMELINE_TO_COMPLETION_STATUS_CHART = () => {
  const barLabel = {
    label: { position: LabelPosition.TOP },
  };

  const formattedData = map(mockTimelineToCompletionStatusData, (item) => ({
    xDateKey: item.name,
    ...item.value,
  }));

  return (
    <DashboardBarChart
      data={formattedData}
      colors={colorsOfengagementTypeCharts}
      fields={TIMELINE_TO_COMPLETION_STATUS_TYPE_LABELS}
      isLoading={false}
      title="Timeline to Completion Status"
      barLabel={barLabel}
      needInsideLabel
    />
  );
};

export default TIMELINE_TO_COMPLETION_STATUS_CHART;
